module.exports = __webpack_public_path__ + "static/media/Procure.a6095dc1.svg";